'use client';
import Container from '@/components/ui/container';
import { useTranslations } from 'next-intl';
import { usePathname } from '@/i18n/navigation';
import { shouldShowMainLayout } from '@/utils/global';

const Copyrights = () => {
  const t = useTranslations('common');
  const pathname = usePathname();
  const showMainBlocks = shouldShowMainLayout(pathname);

  return (
    <section className={`${showMainBlocks ? 'bg-tertiary-100' : 'bg-white'}`}>
      <Container className='py-3 lg:flex lg:max-h-[46px] lg:items-center lg:justify-center lg:py-4'>
        <p className='text-center text-xs sm:text-sm md:text-base'>
          © {new Date().getFullYear()} - {t('All rights reserved by')}{' '}
          <strong>{t('Innova')}</strong>.
        </p>
      </Container>
    </section>
  );
};

export default Copyrights;
